import React from 'react';
import {
  Typography, Row, Col, Form,
} from 'antd';
import {
  SelectLabelWrapper,
  SelectWrapper,
  TitleWrapper,
  Wrapper,
} from './styles';
import passengerIcon from '../../assets/images/passenger.svg';
import StyledSelect from '../CustomAntdComponents/StyledSelect';
import {
  getAdultsOptions,
  getChildrenOptions,
  getInfantOptions,
} from './helper';
import { StyledText } from '../CustomAntdComponents/Typography';
import {
  useFlightSearchStore,
} from '../../store/flightSearch/flightSearchStore';
import globalTranslations from '../../utils/globalTranslation';
import { useI18nContext } from '../../utils/I18n';

type Props = {
  showTitle?: boolean
}
const { Text } = Typography;

function PassengerCountSelector({ showTitle }: Props) {
  const {
    state: { t },
  } = useI18nContext();
  const {
    formData: {
      numberOfAdults, numberOfInfants, numberOfChildren,
    }, updateFormData,
  } = useFlightSearchStore();

  const onFormInputChange = (value: any, name: string) => {
    updateFormData({ [name]: value });
  };

  const checkNumberOfPassenger = () => {
    const totalToddlers = (numberOfInfants || 0);
    const totalPAX = numberOfAdults + (numberOfChildren || 0) + totalToddlers;

    if (totalPAX > 9) {
      return Promise.reject(new Error(
        t(globalTranslations).passengerSelector.maxValidationText,
      ));
    }

    if (numberOfAdults < totalToddlers) {
      return Promise.reject(new Error(
        t(globalTranslations).passengerSelector.unmatchValidationText,
      ));
    }

    return Promise.resolve();
  };

  const adultOptions = getAdultsOptions(t(globalTranslations).passengerSelector.adults, t(globalTranslations).passengerSelector.adult);
  const childrenOptions = getChildrenOptions(t(globalTranslations).passengerSelector.children, t(globalTranslations).passengerSelector.child);
  const infantOptions = getInfantOptions(t(globalTranslations).passengerSelector.infants, t(globalTranslations).passengerSelector.infant);

  return (
    <Wrapper>
      {showTitle && (
      <TitleWrapper>
        <img src={passengerIcon} alt="passenger" />
        <Text strong>
          &nbsp;&nbsp;
          {t(globalTranslations).passengerSelector.title}
        </Text>
      </TitleWrapper>
      )}

      <Row>
        <Col xs={24} lg={0}>
          <Row>
            <Col span={24}>
              <Form.Item
                name="numberOfAdults"
                rules={[
                  {
                    required: false,
                    message: t(globalTranslations).passengerSelector.adultValidationText,
                  },
                ]}
              >
                <Row>
                  <Col xs={16} md={18}>
                    <SelectLabelWrapper>
                      <StyledText type="secondary">
                        { t(globalTranslations).passengerSelector.placeholder.adults}
                      </StyledText>
                    </SelectLabelWrapper>
                  </Col>
                  <Col xs={8} md={6}>
                    <SelectWrapper>
                      <StyledSelect
                        placeholder={t(globalTranslations).passengerSelector.adults}
                        value={numberOfAdults}
                        options={adultOptions}
                        onChange={(value) => onFormInputChange(value, 'numberOfAdults')}
                      />
                    </SelectWrapper>
                  </Col>
                </Row>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item>
                <Row>
                  <Col xs={16} md={18}>
                    <SelectLabelWrapper>
                      <StyledText type="secondary">
                        { t(globalTranslations).passengerSelector.placeholder.children}
                      </StyledText>
                    </SelectLabelWrapper>
                  </Col>
                  <Col xs={8} md={6}>
                    <SelectWrapper>
                      <StyledSelect
                        placeholder={t(globalTranslations).passengerSelector.children}
                        value={numberOfChildren}
                        options={childrenOptions}
                        onChange={(value) => onFormInputChange(value, 'numberOfChildren')}
                      />
                    </SelectWrapper>
                  </Col>
                </Row>

              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                name="numberOfInfants"
                rules={[
                  {
                    validator: checkNumberOfPassenger,
                  },
                ]}
              >
                <Row>
                  <Col xs={16} md={18}>
                    <SelectLabelWrapper>
                      <StyledText type="secondary">
                        { t(globalTranslations).passengerSelector.placeholder.infants}
                      </StyledText>
                    </SelectLabelWrapper>
                  </Col>
                  <Col xs={8} md={6}>
                    <SelectWrapper>
                      <StyledSelect
                        placeholder={t(globalTranslations).passengerSelector.infants}
                        value={numberOfInfants}
                        options={infantOptions}
                        onChange={(value) => onFormInputChange(value, 'numberOfInfants')}
                      />
                    </SelectWrapper>
                  </Col>
                </Row>

              </Form.Item>
            </Col>

          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={0} lg={24}>
          <Form.Item
            name="numberOfAdults"
            rules={[
              {
                required: false,
                message: t(globalTranslations).passengerSelector.adultValidationText,
              },
            ]}
          >
            <StyledSelect
              placeholder={t(globalTranslations).passengerSelector.placeholder.adults}
              value={numberOfAdults}
              options={adultOptions}
              onChange={(value) => onFormInputChange(value, 'numberOfAdults')}
            />
          </Form.Item>
          <Form.Item>
            <StyledSelect
              placeholder={t(globalTranslations).passengerSelector.placeholder.children}
              value={numberOfChildren}
              options={childrenOptions}
              onChange={(value) => onFormInputChange(value, 'numberOfChildren')}
            />
          </Form.Item>
          <Form.Item
            name="numberOfInfants"
            rules={[
              {
                validator: checkNumberOfPassenger,
              },
            ]}
          >
            <StyledSelect
              placeholder={t(globalTranslations).passengerSelector.placeholder.infants}
              value={numberOfInfants}
              options={infantOptions}
              onChange={(value) => onFormInputChange(value, 'numberOfInfants')}
            />
          </Form.Item>
        </Col>
      </Row>
    </Wrapper>

  );
}

PassengerCountSelector.defaultProps = {
  showTitle: true,
};
export default PassengerCountSelector;
